export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    fixed: 'right',
    width: 140,
    showHeaderOverflow: true,
    showOverflow: false,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('table_label_mrpStockTransferNo') || '转库单编号',
    field: 'mrpStockTransferNo',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('INDEX.Status') || '状态',
    field: 'stockTransferStatus',
    headerAlign: 'center',
    minWidth: 90,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
    slots: { default: 'status' }
  },
  {
    title: that.$l('table_label_transferDate') || '转库日期',
    field: 'transferDate',
    headerAlign: 'center',
    minWidth: 100,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_transferType') || '转库类型',
    field: 'v_transferType',
    headerAlign: 'center',
    minWidth: 180,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    title: that.$l('table_label_outWarehouse') || '出库仓库名称',
    field: 'outWarehouseName',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },
  {
    title: that.$l('table_label_inWarehouse') || '入库仓库名称',
    field: 'inWarehouseName',
    headerAlign: 'center',
    minWidth: 150,
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: false,
  },

  {
    title: that.$l('INDEX.creator') || "创建人",
    width: 170,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    slots: {
      default: "createInfo",
    },
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || "修改人",
    width: 170,
    headerAlign: "center",
    align: "center",
    showHeaderOverflow: true,
    slots: { default: "modifyInfo" },
  },

]
